// Detect mobile device
(function (a) {
  (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
})(navigator.userAgent || navigator.vendor || window.opera);

// Check if the browser is IE or Edge...
var uA = window.navigator.userAgent,
onlyIEorEdge = /msie\s|trident\/|edge\//i.test(uA) && !!( document.uniqueID || window.MSInputMethodContext),
checkVersion = (onlyIEorEdge && +(/(edge\/|rv:|msie\s)([\d.]+)/i.exec(uA)[2])) || NaN,
result = document.getElementById('resultado');

document.getElementById('detalles').innerHTML = uA;

result.innerHTML = !isNaN(checkVersion) ? 'You\'re using ' + (checkVersion >= 12 ? 'Microsoft Edge ' : 'Windows Internet Explorer ') + checkVersion : 'You\'re not using Microsoft\'s Browser.';

// EXAMPLE
// if ($.browser.mobile) {
//   // Mobile things
// } else {
//   // Desktop things
// }

// End detect mobile device

// Stop video jumping
// console.log(result.innerHTML);

$(document).ready(function () {
  if ($.browser.mobile || result.innerHTML !== "You're not using Microsoft's Browser.") {
    // console.log("IE");
    $(".our_benefits_section").css("background-attachment", "inherit");
    $(".banner_image").css("background-attachment", "inherit");
       
  } else {
    // console.log("Chrome");
      $(".our_benefits_section").css("background-attachment", "fixed");
      $(".banner_image").css("background-attachment", "fixed");
  }
});



// Detect if it has blend mode

var blend_detect = document.createElement("div");
if ("backgroundBlendMode" in window.getComputedStyle(blend_detect)) {
  document.body.className += " cssBackgroundBlendMode";
} else {
 document.body.className += " noCssBackgroundBlendMode";

  $(".footer_first").css({
      "background-color":"none"    
  });

  $(".footer_cover").css({
    "height":"100%",
    "background-color":"rgba(15, 53, 117, 0.73)"
  });
} 



// Add-on function for Owl Carousel. Adds class to first and last slides.
function checkClasses() {
  var total = $('.owl-carousel .owl-stage .owl-item.active').length;
  $('.owl-carousel .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');
  $('.owl-carousel .owl-stage .owl-item.active').each(function (index) {
    if (index === 0) {
      // this is the first one
      $(this).addClass('firstActiveItem');
    }
    if (index === total - 1 && total > 1) {
      // this is the last one
      $(this).addClass('lastActiveItem');
    }
  });
}
// End add-on function for Owl Carousel.

// Jarallax
$(document).ready(function () {
  if ($.browser.mobile || result.innerHTML !== "You're not using Microsoft's Browser.") {
    // Do nothing for mobile
    // console.log("im IE and not chrome");
  } else {
    $(".jarallax").each(function () {
      $(this).jarallax({
        speed: 0.5
      });
    });
  }
});
// End jarallax

// Top Navigation
$('.top_sub_nav ul li a').hover(function () {
  TweenMax.to($(this).prev(), 0.5, { // Add tweenmax.
    autoAlpha: 1.0,
    ease: Power2.easeInOut
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(this).prev(), 0.5, { // Add tweenmax.
    autoAlpha: 0.0,
    ease: Power2.easeInOut
  });
});



// Banner Go to by Scroll

$(".bottom_arrow").on("click", function () {
  goToByScroll(".go_top", 0, 0.5);
});

// Home page
$(".arrow_down").on("click", function () {
  goToByScroll(".top_of_page", 0, 1);
});

$(document).ready(function () {
  var flag_carousel = $(".flag_carousel");
  flag_carousel.owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      1400: {
        items: 5,
        nav: true
      },
      1366: {
        items: 4,
        nav: true
      },
      991: {
        items: 3,
        nav: true
      },
      0: {
        items: 1,
        nav: true
      }
    },
    navText: ['<div class="owl_prev_custom">PREV</div>', '<div class="owl_next_custom">NEXT</div>']
  });
  checkClasses();
  flag_carousel.on('translated.owl.carousel', function (event) {
    checkClasses();
  });
});

$(document).ready(function () {
  var projects_carousel = $(".projects_carousel");
  projects_carousel.owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      1199: {
        items: 2,
        nav: true
      },
      0: {
        items: 1,
        nav: true
      },
    },
    navText: ['<div class="owl_prev_custom">PREV</div>', '<div class="owl_next_custom">NEXT</div>']
  });
  checkClasses();
  projects_carousel.on('translated.owl.carousel', function (event) {
    checkClasses();
  });
});

$(document).ready(function () {
  var testimonials_carousel = $(".testimonials_carousel");
  testimonials_carousel.owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 1,
    nav: true,
    navText: ['<div class="owl_prev_custom">PREV</div>', '<div class="owl_next_custom">NEXT</div>']
  });
  checkClasses();
  testimonials_carousel.on('translated.owl.carousel', function (event) {
    checkClasses();
  });
});

$(document).ready(function () {
  $('.project_block').hover(function () {
    TweenMax.to($(this).find(".project_block_inner_overlay"), 0.5, { // Add tweenmax.
      autoAlpha: 1.0
    });
  }, function () { // This acts like a roll off state.
    TweenMax.to($(this).find(".project_block_inner_overlay"), 0.5, { // Add tweenmax.
      autoAlpha: 0.0
    });
  });
});

// End home page

// Bottom form/testimonial section
$(document).ready(function () {
  setTimeout(function () {
    $(".get_in_touch_section .testimonial_slider").css("height", $(".get_in_touch_section .form_wrapper").css("height"));
  }, 1000);
});
// End bottom form/testimonial section

// Contact banner
$("#gform_wrapper_2 #field_2_1, #field_2_2, #field_2_3, #field_2_4, #field_2_5").wrapAll('<div class="left_form_side"></div>');
$("#gform_wrapper_2 .gform_footer").appendTo("#gform_wrapper_2 #field_2_6");
// End contact banner

// Projects Page
if ($("body").hasClass("post-type-archive-projects") && window.location.search.indexOf("sort") > -1 && window.location.search.indexOf("sortby") > -1) {
  var dropdown_search = window.location.search.substring(1).split("&");
  console.log(dropdown_search);
  if (dropdown_search[0] === "sort=location" && dropdown_search[1] === "sortby=desc") {
    $(".projects_banner .sorting_options_dropdown select").val("location");
  } else if (dropdown_search[0] === "sort=most_recent" && dropdown_search[1] === "sortby=desc") {
    $(".projects_banner .sorting_options_dropdown select").val("most_recent");
  } else {
    $(".projects_banner .sorting_options_dropdown select").val("project");
  }
  goToByScroll(".projects_banner", 0, 0);
}

$(".projects_banner .sorting_options_dropdown select").change(function () {
  if ($(this).val() === "location") {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=location&sortby=desc";
  } else if ($(this).val() === "most_recent") {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=most_recent&sortby=desc";
  } else {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=project&sortby=desc";
  }
});
// End projects page

// Flagpoles Page sorting options 

if ($("body").hasClass("page-template-page-flagpoles") && window.location.search.indexOf("sort") > -1 && window.location.search.indexOf("sortby") > -1) {
  var dropdown_search = window.location.search.substring(1).split("&");
  // console.log(dropdown_search);
  if (dropdown_search[0] === "sort=most_recent" && dropdown_search[1] === "sortby=desc") {
    $(".flagpoles_banner .sorting_options_dropdown select").val("most_recent");
  } else if (dropdown_search[0] === "sort=price_lowest" && dropdown_search[1] === "sortby=desc") {
    $(".flagpoles_banner .sorting_options_dropdown select").val("price_lowest");
  } else if (dropdown_search[0] === "sort=price_highest" && dropdown_search[1] === "sortby=desc") {
    $(".flagpoles_banner .sorting_options_dropdown select").val("price_highest");
  } else {
    $(".flagpoles_banner .sorting_options_dropdown select").val("name");
  }
  goToByScroll(".flagpoles_banner", 0, 0);
}

$(".flagpoles_banner .sorting_options_dropdown select").change(function () {
  if ($(this).val() === "most_recent") {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=most_recent&sortby=desc";
  } else if ($(this).val() === "price_lowest") {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=price_lowest&sortby=desc";
  } else if ($(this).val() === "price_highest") {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=price_highest&sortby=desc";
  } else {
    window.location.href = window.location.origin + window.location.pathname + "/?sort=name&sortby=desc";
  }
});
// End flagpoles page

// Single Product Form

$('.form_button').click(function () {
  $(".fourth_section_form").css("display", "block");
  $(".third_section").css("display", "none");
  goToByScroll(".fourth_section_form", 0, 0.5);
});

// $('.contact_book_demo').click(function() {
//   $(".request_demo").css("display", "block");
//   $(".request_demo").css("opacity", "1");
//   goToByScroll(".request_demo", 0, 0.5);
//   $(".general_enquiry_form").css("display", "none");
//   $(".customer_support_form").css("display", "none");
// });



// Home Page Hovers 

$('.journey_block').hover(function () {
  TweenMax.to($(this).find(".cover_even"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    backgroundColor: '#e8891c'
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(this).find(".cover_even"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    backgroundColor: 'rgba(0, 71, 108, 0.50)'
  });
});

$('.journey_block').hover(function () {
  TweenMax.to($(this).find(".cover_odd"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    backgroundColor: '#e8891c'
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(this).find(".cover_odd"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    backgroundColor: 'rgba(0, 71, 108, 0.50)'
  });
});


// About Page Hovers 

$(".about_more").on("click", function () {
  var show_hidden_shit = $(this).attr("data-attr");
  $(".more_content").hide();
  $("." + show_hidden_shit).show();
  goToByScroll($("." + show_hidden_shit), 0, 0.8);
});


$('.about_hover_link').hover(function () {
  TweenMax.to($(".cover_about", this), 0.5, { // Add tweenmax.
    opacity: '0',
    ease: Power2.easeInOut,
    top: '260',
    scaleY: 0,
    transformOrigin: "bottom top"
  });
  TweenMax.to($(".about_cover_fill", this), 0.5, { // Add tweenmax.
    opacity: '1',
    ease: Power1.easeInOut,
    delay: 0.5
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(".cover_about", this), 0.5, { // Add tweenmax.
    opacity: '1',
    ease: Power2.easeInOut,
    top: '0',
    scaleY: 1,
    transformOrigin: "bottom top"
  });
  TweenMax.to($(".about_cover_fill", this), 0.5, { // Add tweenmax.
    opacity: '0',
    ease: Power1.easeInOut,
    delay: 0.5
  });
});




$('.SURGE_slide_buttons').hover(function () {
  TweenMax.to($(".arrow-1", this), 0.5, { // Add tweenmax.
    fill: '#007246',
    ease: Power4.easeInOut,
  });
  TweenMax.to($(".arrow-2", this), 0.5, { // Add tweenmax.
    stroke: '#8dc63f',
    ease: Power4.easeInOut,
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(".arrow-1", this), 0.5, { // Add tweenmax.
    fill: '#8dc63f',
    ease: Power4.easeInOut,
  });
  TweenMax.to($(".arrow-2", this), 0.5, { // Add tweenmax.
    stroke: '#fff',
    ease: Power4.easeInOut,
  });
});




// Side Menu 

var menuLeft = document.getElementById('cbp-spmenu-s1'),
  menuRight = document.getElementById('cbp-spmenu-s2'),
  menuTop = document.getElementById('cbp-spmenu-s3'),
  menuBottom = document.getElementById('cbp-spmenu-s4'),
  showLeft = document.getElementById('showLeft'),
  showRight = document.getElementById('showRight'),
  showTop = document.getElementById('showTop'),
  showBottom = document.getElementById('showBottom'),
  showLeftPush = document.getElementById('showLeftPush'),
  showRightPush = document.getElementById('showRightPush'),
  body = document.body;

// showLeft.onclick = function() {
//   classie.toggle( this, 'active' );
//   classie.toggle( menuLeft, 'cbp-spmenu-open' );
//   disableOther( 'showLeft' );
// };
// showRight.onclick = function() {
//   classie.toggle( this, 'active' );
//   classie.toggle( menuRight, 'cbp-spmenu-open' );
//   disableOther( 'showRight' );
// };
// showTop.onclick = function() {
//   classie.toggle( this, 'active' );
//   classie.toggle( menuTop, 'cbp-spmenu-open' );
//   disableOther( 'showTop' );
// };
// showBottom.onclick = function() {
//   classie.toggle( this, 'active' );
//   classie.toggle( menuBottom, 'cbp-spmenu-open' );
//   disableOther( 'showBottom' );
// };
showLeftPush.onclick = function () {
  classie.toggle(this, 'active');
  classie.toggle(body, 'cbp-spmenu-push-toright');
  classie.toggle(menuLeft, 'cbp-spmenu-open');
  // disableOther( 'showLeftPush' );
};
// showRightPush.onclick = function() {
//   classie.toggle( this, 'active' );
//   classie.toggle( body, 'cbp-spmenu-push-toleft' );
//   classie.toggle( menuRight, 'cbp-spmenu-open' );
//   disableOther( 'showRightPush' );
// };

// function disableOther( button ) {
//   if( button !== 'showLeft' ) {
//     classie.toggle( showLeft, 'disabled' );
//   }
//   if( button !== 'showRight' ) {
//     classie.toggle( showRight, 'disabled' );
//   }
//   if( button !== 'showTop' ) {
//     classie.toggle( showTop, 'disabled' );
//   }
//   if( button !== 'showBottom' ) {
//     classie.toggle( showBottom, 'disabled' );
//   }
//   if( button !== 'showLeftPush' ) {
//     classie.toggle( showLeftPush, 'disabled' );
//   }
//   if( button !== 'showRightPush' ) {
//     classie.toggle( showRightPush, 'disabled' );
//   }
// }


// Nav Menu Burger Menu

$('.nav-icon1').click(function () {
  $('.main_nav').toggleClass('menuOpen');
  $(this).toggleClass('open');
});




// Nav Drop Down

$('li.is_dropdown.parent_li').hover(function () {
  $(".mega_dropdown").css("opacity", "0");
  $(this).find(".mega_dropdown").css("opacity", "1");
  var tl = new TimelineMax();
  TweenLite.killTweensOf(".mega_dropdown > li");
  TweenLite.set(".mega_dropdown > li", {
    clearProps: "all"
  });
  // tl.from('.mega_dropdown', .25, {
  //   ease: Power2.easeOut,
  //   transformOrigin: "top",
  //   rotationY: 90
  // })
  tl.staggerFrom('.mega_dropdown > li', .2, {
    ease: Power1.easeIn,
    y: -20,
    opacity: 0
  }, .015);
  // tl.staggerFrom('.mega_dropdown > li a', .2, {ease: Power1.easeIn, opacity: 0, x: -60}, .01); 
}, function () {
  $(".mega_dropdown").css("opacity", "0");
});




// Footer Social Buttons 

// $('.linkedin, .facebook, .twitter').hover(function() {
//   console.log("Hovered");
//   TweenMax.to($(this).find(".cls-1"), 0.5, { // Add tweenmax.
//     fill: '#024e80',
//     ease: Quad.easeInOut
//   });
//   TweenMax.to($(this).find(".cls-2"), 0.5, { // Add tweenmax.
//     fill: '#fff',
//     ease: Quad.easeInOut
//   });
// }, function() { // This acts like a roll off state.
//   TweenMax.to($(this).find(".cls-1"), 0.5, { // Add tweenmax.
//     fill: '#024e80',
//     ease: Quad.easeInOut
//   });
//   TweenMax.to($(this).find(".cls-2"), 0.5, { // Add tweenmax.
//     fill: '#fff',
//     ease: Quad.easeInOut
//   });
// });






// Scroll to top 

$(document).ready(function () {

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('.scrollup').fadeIn();

    } else {
      $('.scrollup').fadeOut();
    }
  });

  $('.scrollup').click(function () {
    $("html, body").animate({
      scrollTop: 0
    }, 600);
    return false;
  });

});



// Roll Overs For Mid CTA:

$('.case_wrapper_link').hover(function () {
  TweenMax.to($(this).find(".blue_button"), 0.5, { // Add tweenmax.
    backgroundColor: '#9EB3BE',
    ease: Power3.easeInOut
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(this).find(".blue_button"), 0.5, { // Add tweenmax.
    backgroundColor: '#4d95ba',
    ease: Power3.easeInOut
  });
});




// Blog expandable areas

$(".row_year").on("click", function () {
  var that = this;
  $(".years_posts").css("display", "none");
  $(".row_year .icon").css("transform", "none");
  $(that).next().css("display", "block");
  TweenMax.to($(that).find(".icon"), 0.4, { // Fill the middle
    ease: Power3.easeInOut,
    rotation: 180
  });
});

$(".row_cat").on("click", function () {
  var that = this;
  $(".recent_posts").css("display", "none");
  $(".row_cat .icon").css("transform", "none");
  $(that).next().css("display", "block");
  TweenMax.to($(that).find(".icon"), 0.4, { // Fill the middle
    ease: Power3.easeInOut,
    rotation: 180
  });
});

// End blog expandable areas


// Expandable Content. Add Display none on the Elements in the CSS.

$(".expand_button").on("click", function () {
  if ($(this).hasClass("open")) {
    TweenMax.set($(this).find("svg"), {
      rotation: "0",
      ease: Power1.easeInOut
    });
    TweenMax.set($(this).find(".cls-1"), {
      ease: Power1.easeInOut,
      fill: "#c0c8d3"
    });
    TweenMax.set($(this).closest(".the_row").find(".hidden_content_wrapper"), {
      display: "none",
      padding: "0px"
    });
    $(this).removeClass("open");
  } else {
    goToByScroll($(this).parent().parent().parent(), 10, 0.5);
    TweenMax.set(".expandable_row", {
      // borderBottom: "2px solid #89C3C0"
    });
    TweenMax.set(".expand_button svg", {
      rotation: "0"
    });
    TweenMax.set(".hidden_content_wrapper", {
      display: "none",
      padding: "0px"
    });
    $(".expand_button").removeClass("open");
    $(this).addClass("open");
    TweenMax.set($(this).parent().parent().parent(), {
      borderBottom: "none"
    });
    TweenMax.set($(this).find('svg'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
    TweenMax.set($(this).find(".cls-1"), {
      ease: Power1.easeInOut,
      fill: "#f68b28"
    });
    TweenMax.set($(this).parent().parent().parent().next(), {
      display: "block",
      padding: "10px 0"
    });
  }
});

$(".expandable_row h3").on("click", function () {
  $(this).closest(".the_row").find(".expand_button").trigger("click");
});




//  Out Team Hide and Show a Repater with attr

$(".learmore_btn").on("click", function () {
  var class_to_show = $(this).attr("data-attr");
  $(".the_childs_journey").hide();
  $("." + class_to_show).show();
  // console.log(class_to_show);
  goToByScroll($("." + class_to_show), 0, 0.8);
});


// $(document).on("click", ".close_btn", function() {
//   $(this).parent().css("display", "none");
// });



// $('#SURGE_GSAP_slider_journey').each(function(i) {

//  var thisID = $(this).attr('id');
//  console.log(thisID);

//  $(this).attr('id', thisID + '-' + i);
//  console.log(thisID);

// });

// Team Page Categories Show Hide


$(document).ready(function () {
  $('.select_group_bar span').click(function () {
    $(this).siblings('span').removeClass('active');
    $(this).addClass('active');
  });
});

$(".select_group_bar span").on("click", function () {
  //console.log($(this).attr("data-attr"));
  var block_to_open = $(this).attr("data-attr");
  if ($(this).attr("data-attr") == "all") {
    $(".team_group_wrapper").css("display", "block");
  } else {
    $(".team_group_wrapper").css("display", "none");
    $(block_to_open).css("display", "block");
    goToByScroll($(block_to_open), 0, 0.8);
  }
});

$(".team_slider_wrapper").on("click", function () {
  var that = this;
  $(".hidden_content_row").css("display", "none");
  $(this).closest(".row-centered").next().css("display", "block");
  goToByScroll($(this).closest(".row-centered").next(), 0, 0.8);
  // $( ".staff_description" ).clone().prependTo($(".hidden_content_row") );
  $(this).closest(".row-centered").next().html($(that).find(".staff_description").html());
  // console.log();
});

$(".features_button").on("click", function () {
  $(".hidden_features").css("display", "none");
  $(this).closest(".service_content_bar").next().css("display", "block");
  goToByScroll($(this).closest(".service_content_bar").next(), 0, 0.5);
});

$(document).on("click", ".view_profile_button", function () {
  var that = this;
  hidden_area_to_open = $(that).closest(".team_member_block").attr("data-attr");
  $(hidden_area_to_open).html($(that).closest(".team_member_block").next().html());
  $(".hidden_content_area").css("display", "none");
  $(hidden_area_to_open).css("display", "block");
  goToByScroll($(hidden_area_to_open), 10, 0.5);
});

$(document).on("click", ".book_this_room_button", function () {
  var this_attr = $(this).attr('data-attr');
  console.log(this_attr);
  $(".training_room_row").css("display", "none");
  $("." + this_attr).css("display", "block");
  goToByScroll($("." + this_attr), 0, 0.5);
  go
});


// About Page


$('.team_member_outer').hover(function () {
  TweenMax.to($(this).find(".team_hidden"), 0.5, { // Add tweenmax.
    display: 'block',
    ease: Power1.easeInOut,
    opacity: '1'
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(this).find(".team_hidden"), 0.5, { // Add tweenmax.
    display: 'none',
    ease: Power1.easeInOut,
    opacity: '0'
  });
});

$('.single_team_member_outer').hover(function () {
  TweenMax.to($(this).find(".team_image_hover"), 0.5, { // Add tweenmax.
    display: 'block',
    ease: Power1.easeInOut,
    opacity: '1'
  });
}, function () { // This acts like a roll off state.
  TweenMax.to($(this).find(".team_image_hover"), 0.5, { // Add tweenmax.
    display: 'none',
    ease: Power1.easeInOut,
    opacity: '0'
  });
});


// Single Image Scroll 

if ($("body").hasClass("single-team")) {
  $(function () {

    var $image_team_scroll = $("#image_team_scroll"),
      $window = $(window),
      offset = $image_team_scroll.offset(),
      topPadding = 20;

    $window.scroll(function () {
      if ($window.scrollTop() > offset.top) {
        $image_team_scroll.stop().animate({
          marginTop: $window.scrollTop() - offset.top + topPadding
        });
      } else {
        $image_team_scroll.stop().animate({
          marginTop: 0
        });
      }
    });

  });
}

// Single Products

$(".description_btn").on("click", function () {
  if ($(".hidden_description").css("display") == "none") {
    $(".hidden_description").css("display", "block");
    TweenMax.to($(".hidden_description"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".long_description").find('.down_tick'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".hidden_description").css("display", "none");
    TweenMax.to($(".hidden_description"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".long_description").find('.down_tick'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});

$(".tech_btn").on("click", function () {
  if ($(".hidden_tech").css("display") == "none") {
    $(".hidden_tech").css("display", "block");
    TweenMax.to($(".hidden_tech"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".tech_description").find('.down_tick'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".hidden_tech").css("display", "none");
    TweenMax.to($(".hidden_tech"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".tech_description").find('.down_tick'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});

$(".faqs_btn").on("click", function () {
  if ($(".hidden_faqs").css("display") == "none") {
    $(".hidden_faqs").css("display", "block");
    TweenMax.to($(".hidden_faqs"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".faqs_description").find('.down_tick'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".hidden_faqs").css("display", "none");
    TweenMax.to($(".hidden_faqs"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".faqs_description").find('.down_tick'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});

$(".downloads_btn").on("click", function () {
  if ($(".hidden_downloads").css("display") == "none") {
    $(".hidden_downloads").css("display", "block");
    TweenMax.to($(".hidden_downloads"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".downloads_description").find('.down_tick'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".hidden_downloads").css("display", "none");
    TweenMax.to($(".hidden_downloads"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".downloads_description").find('.down_tick'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});


$(".question").on("click", function () {
  if ($(this).next().css("display") == "none") {
    $(this).next().css("display", "block");
    TweenMax.to($(this).next(), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
  } else {
    $(this).next().css("display", "none");
    TweenMax.to($(this).next(), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
  }
});

$(".install_button").on("click", function () {
  if ($(".install_hidden").css("display") == "none") {
    $(".install_hidden").css("display", "block");
    TweenMax.to($(".install_hidden"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".install_wrapper").find('.arrow_white'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".install_hidden").css("display", "none");
    TweenMax.to($(".install_hidden"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".install_wrapper").find('.arrow_white'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});


$(".artwork_button").on("click", function () {
  if ($(".artwork_hidden").css("display") == "none") {
    $(".artwork_hidden").css("display", "block");
    TweenMax.to($(".artwork_hidden"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".artwork_wrapper").find('.arrow_white'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".artwork_hidden").css("display", "none");
    TweenMax.to($(".artwork_hidden"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".artwork_wrapper").find('.arrow_white'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});

$(".advice_button").on("click", function () {
  if ($(".advice_hidden").css("display") == "none") {
    $(".advice_hidden").css("display", "block");
    TweenMax.to($(".advice_hidden"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".advice_wrapper").find('.arrow_white'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".advice_hidden").css("display", "none");
    TweenMax.to($(".advice_hidden"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".advice_wrapper").find('.arrow_white'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});

$(".technical_button").on("click", function () {
  if ($(".technical_hidden").css("display") == "none") {
    $(".technical_hidden").css("display", "block");
    TweenMax.to($(".technical_hidden"), 0.3, {
      autoAlpha: 1,
      height: "auto",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".technical_wrapper").find('.arrow_white'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
  } else {
    $(".technical_hidden").css("display", "none");
    TweenMax.to($(".technical_hidden"), 0.3, {
      autoAlpha: 0,
      height: "0px",
      ease: Power1.easeInOut
    });
    TweenMax.set($(".technical_wrapper").find('.arrow_white'), {
      rotation: "0",
      ease: Power1.easeInOut
    });
  }
});






// Blog section
$(".recent_post_btn").on("click", function () {
  $(".recent_wrap").css("display", "block");
  TweenMax.to($(".recent_wrap"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
  $(".archive_wrap").css("display", "none");
  TweenMax.to($(".archive_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
  $(".categories_wrap").css("display", "none");
  TweenMax.to($(".categories_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
});

$(".archive_btn").on("click", function () {
  $(".archive_wrap").css("display", "block");
  TweenMax.to($(".archive_wrap"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
  $(".recent_wrap").css("display", "none");
  TweenMax.to($(".recent_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
  $(".categories_wrap").css("display", "none");
  TweenMax.to($(".categories_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
});

$(".categories_btn").on("click", function () {
  $(".categories_wrap").css("display", "block");
  TweenMax.to($(".categories_wrap"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
  $(".archive_wrap").css("display", "none");
  TweenMax.to($(".archive_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
  $(".recent_wrap").css("display", "none");
  TweenMax.to($(".recent_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
});



// Move the number for basket icon

var length = $(".count_num").text().length;
// console.log(length);

if (length > 1) {
  $(".count_num").css("left", "-3px");
}

$(".woocommerce-order-overview").next("p").addClass("pay_title");


// Search show hide

$(".search_btn").on("click", function () {
  $(".search_it").css("display", "block");
  TweenMax.to($(".search_it"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
});

$(".close_btn").on("click", function () {
  $(".search_it").css("display", "none");
  TweenMax.to($(".search_it"), 0.3, {
    autoAlpha: 0,
    y: "-510px",
    ease: Power1.easeInOut
  });
});


$(document).ready(function () {
  if (window.location.href.indexOf("?s=") > -1) {
    goToByScroll(".products_container", 0, 0.5);
  }
});


// Products Page

$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("angled-head-flag") || $("body").hasClass("world-flags") || $("body").hasClass("naval-and-military-flags") || $("body").hasClass("home-nations") || $("body").hasClass("giant-crowd-flag") || $("body").hasClass("feather-flags")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Flag Type");
      }

    }
  }, 300);
});

$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("wall-mounted-flagpoles")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Metal Type");
      }

    }
  }, 300);
});

$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("wall-mounted-banner-poles")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Range Type");
      }

    }
  }, 300);
});

$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("rigged-flagpole")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Metal Type");
      }

    }
  }, 300);
});

$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("forecourt-flagpoles")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Vehicle Type");
      }

    }
  }, 300);
});

$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("show-home-flagpole")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Metal Type");
      }

    }
  }, 300);
});


$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("garden-flagpole")) {

      if ($('.variations label[for=pa_option-type]').text().indexOf('Option Type') > -1) {
        $(".variations label[for=pa_option-type]").text("Pole Type");
      }

    }
  }, 300);
});


$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("garden-flagpole")) {

      if ($('.variations label[for=pa_pole-options]').text().indexOf('Pole Options') > -1) {
        $(".variations label[for=pa_pole-options]").text("Metal Type");
      }

    }
  }, 300);
});

$(document).ready(function() {
  if ($("body.single-product").find("p.price").text().indexOf("9999") > -1) {
    console.log("Found it!");
    $("p.price").text("Price on request");
    $(".availability, .starting, .cart_quantity_wrapper, .variations_form").css("display", "none");
    $(".single_product_enquire_button").css("display", "inline-block");
  }

if ($("body.single-product").find("p.price span").text().indexOf("9,999") > -1) {
  console.log("Found it!");
  $("p.price span").text("Price on request");
  $(".availability, .starting, .cart_quantity_wrapper, .variations_form").css("display", "none");
  $(".single_product_enquire_button").css("display", "inline-block");
}

  $("body.page-template-page-flagpoles .project_block .price").each(function() {
    if ($(this).text().indexOf("9,999") > -1) {
      $(this).text("Price on request");
      $(this).next().text("View");
    }
  })
  $("body.page-template-page-banner-poles .project_block .price").each(function() {
    if ($(this).text().indexOf("9,999") > -1) {
      $(this).text("Price on request"); 
      $(this).next().text("View"); 
    }
  })
});



$("span.woocommerce-Price-amount").change(function() {
  if ($(this).text().indexOf("9,999") > -1) {
    console.log("Found it!");
    $(this).text("Price on request");
    $(".availability, .starting, .cart_quantity_wrapper, .variations_form").css("display", "none");
    $(".single_product_enquire_button").css("display", "inline-block");
  }
});
